import React from "react";
import { VerifyMapOutputContainer } from "../../../containers";

const VerifyMap = (props) => {
  return <VerifyMapOutputContainer />;
};

export default VerifyMap;
